import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'hub', component: () => import('@/views/HubView.vue') },
    { path: '/review/:cat?', name: 'review', component: () => import('@/views/ReviewView.vue'), props: true },
    { path: '/paste', name: 'paste', component: () => import('@/views/PasteView.vue') },
    { path: '/taste', name: 'taste', component: () => import('@/views/InsightsView.vue') },
    { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

export default router
